import { useEffect, useState } from "react";
import { getCachedBlob } from "./blob-cache-persistent";

export const useCachedFile = (fileUrl?: string | null) => {
  const [cachedFile, setCachedFile] = useState<{ blob: Blob; url: string } | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;
    if (!fileUrl) {
      setCachedFile(null);
      return;
    }

    const load = async () => {
      setLoading(true);
      try {
        const cached = await getCachedBlob(fileUrl);
        if (!cancelled) setCachedFile(cached);
      } catch (err) {
        console.error("Failed to load cached file", err);
        if (!cancelled) setCachedFile(null);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, [fileUrl]);

  return { cachedFile, loading };
};
